<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      {{
        $store.state.redirectview == "PointManager" ? "เปลี่ยน" : "ลืม"
      }}รหัสผ่าน
    </div>
    <div class="mb-2">
      <v-btn @click="back" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="text-center" style="font-size: 20px">
      กรุณากรอก เลขบัตรประชาชน ที่ท่านสมัครสมาชิก
    </div>
    <div class="px-4 pt-5">
      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
            digits: 13,
          }"
          name="เลขบัตรประชาชน"
          v-slot="{ errors }"
        >
          <div>
            <v-text-field
              v-model="input.identityNumber"
              :error-messages="errors"
              outlined
            ></v-text-field>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center">
        <v-btn :loading="loading" @click="next" color="primary">ยืนยัน</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
  },

  methods: {
    back() {
      if (this.$store.state.redirectview) {
        this.query.view = this.$store.state.redirectview;
      } else {
        this.query.view = "Login";
      }
    },
    async next() {
      if (await this.$refs.observer.validate()) {
        var data = {
          identity_number: this.input.identityNumber,
        };
        this.loading = true;
        axios
          .get(this.serverUrl + "toacrm/member-by-identitynumber", {
            params: data,
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            this.loading = false;
            if (response.data.responsecode == 200) {
              Object.assign(this.input, { ...response.data.data[0] });
              this.$emit("nextstep");
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>